
import { Component, Prop, Provide, Vue } from 'nuxt-property-decorator'
import orderBy from 'lodash/orderBy'

import { Emotion } from '../service/scheme'
import EmotionModal from './EmotionModal.vue'
import { NeoButton, NeoIcon, NeoTooltip } from '@kodadot1/brick'

const issuerId = (emotion: Emotion) => emotion.caller

interface GroupedEmotion {
  [x: string]: Emotion[]
}

interface Emoji {
  key: string
  count: number
  issuers: string[]
  parsed: string
}

@Component({
  components: {
    Identity: () => import('@/components/identity/IdentityIndex.vue'),
    NeoIcon,
    NeoTooltip,
    NeoButton,
  },
})
export default class EmotionList extends Vue {
  @Prop() public emotions!: GroupedEmotion
  @Provide() DISPLAYED_EMOJI = 5

  /**
   * parse emoji from codepoint to emoji
   * @param codepoint Emoji Codepoint
   * @returns Emoticon 👨🏻‍🌾
   */
  parseEmoji(codepoint): string {
    if (codepoint) {
      const toInt = codepoint.split('-').map((code) => parseInt(code, 16))
      return String.fromCodePoint.apply(String, toInt)
    }

    return ''
  }

  openEmotionModal(): void {
    this.$buefy.modal.open({
      parent: this,
      component: EmotionModal,
      canCancel: ['escape', 'outside'],
      hasModalCard: true,
      props: {
        emotes: this.emotes,
      },
    })
  }

  get emotes(): Emoji[] {
    const mapping = Object.entries(this.emotions).map(([key, emotions]) => ({
      key,
      count: emotions.length,
      issuers: emotions.map(issuerId),
      parsed: this.parseEmoji(key),
    }))
    const orderByCount = orderBy(mapping, ['count'], ['desc'])

    return orderByCount
  }
}
